/**
 * Mask all but the last two characters of a contact value.
 *
 * Purely presentational: the server capability, not this function, is the authorization boundary.
 * The review DTO carries raw values on the wire by design, so masking exists to keep a shared
 * waiting-room terminal from displaying a patient's full number to whoever is standing behind them.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * import { maskValue } from "./masking";
 *
 * maskValue("+4930123456"); // => "••••••••56"
 * ```
 */
export function maskValue(value: string): string {
  const visible = value.slice(-2);
  return value.length <= 2
    ? value
    : `${"•".repeat(Math.min(value.length - 2, 8))}${visible}`;
}
